(function(angular) {
  'use strict';

  var app = angular.module('asSupplyMgr');

  app.service('sourcesApi', [
    '$http',
    '$q',
    function($http, $q) {
      this.getList = (sort, search, page, statusFilter) => {
        let url = '/supply/inventory/sources/list' + getReportUrl(sort, search, {'status': statusFilter}, page);

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              console.log(res);
              resolve(res.data);
            },
            res => {
              console.log(res);
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.changeState = (id, state) => {
        const url = '/supply/inventory/sources/state';

        return $q((resolve, reject) => {
          $http.post(url, { id, state }).then(
            res => {
              resolve(res);
            },
            res => {
              console.log(res);
              reject(res);
            }
          );
        });
      };

      this.getTypes = () => {
        const url = '/supply/inventory/sources/types';

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data.types);
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.delete = id => {
        const url = `/supply/inventory/sources?id=${id}`;

        return $q((resolve, reject) => {
          $http.delete(url).then(
            res => {
              resolve(res);
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.save = source => {
        let url = '/supply/inventory/sources/save';

        return $q((resolve, reject) => {
          $http.post(url, source).then(
            res => {
              if (res.data.status === 'success') {
                  resolve();
              } else {
                  reject(res.data);
              }
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.read = id => {
        let url = `/supply/inventory/sources/read?id=${id}`;

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data);
            },
            res => {
              reject();
            }
          );
        });
      };
    },
  ]);
})(window.angular);
